import { useEffect, useState } from "react";
import ModalBase from "../modals/ModalBase";
import { useAuth } from "../../js/hooks/useAuth";
import { hasSeenBetaWelcome, markBetaWelcomeSeen } from "../../js/auth/betaUi";

/** First-login welcome for users with betaTester: true. */

export default function BetaWelcomeModal() {
  const { session } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!session?.betaTester || !session.userId) {
      setOpen(false);
      return;
    }
    setOpen(!hasSeenBetaWelcome(session.userId));
  }, [session?.betaTester, session?.userId]);

  if (!session?.betaTester) return null;

  function begin() {
    markBetaWelcomeSeen(session.userId);
    setOpen(false);
  }

  return (
    <ModalBase
      isOpen={open}
      title="Welcome to the REChecklist Beta Tester Program"
      onClose={begin}
      wide
      welcome
      hideClose
    >
      <p>
        You’re now inside your early-access version of REChecklist. Thank you again for helping us
        refine the system.
      </p>
      <p>
        If you ever feel stuck, or simply want to chat about a feature, support is just a message
        away. You can reach us anytime through your built-in messaging panel. During the beta phase,
        responses may not always be immediate, but you can expect a reply within a short period of
        time.
      </p>
      <p>
        Your Desk is always available in the upper-right corner of your navigation bar. This is your
        command center — where you’ll find your clients, your workflow tools, your notes, and your
        support messages.
      </p>
      <p>
        Feel free to explore, create a new buyer or seller, enter real client information, and use
        the system as if it’s already yours. We want this to be a smooth, enjoyable experience —
        your new real estate business wonder-tool.
      </p>
      <div className="beta-welcome-actions">
        <button type="button" className="primary-btn" onClick={begin}>
          Let’s Begin
        </button>
      </div>
    </ModalBase>
  );
}
